<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import router from "../../router";
import Alert from "@/components/Alert";
import EventBus from "@/eventBus";
import accessible from '@/mixins/accessible'

export default {
  name: "Items",
  components: {
    ErrorComponent,
    Alert,
    Pagination
  },
  data() {
    return {
      list: [],
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      currentSorting: "",
      checkedItems: [],
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        search: "",
        category_id: "",
        store_id: "",
        stock: ""
      },
      stores: [],
      categories: [],
      item_obj: {},
      decimal_separator: ".",
      precision: 0,
      currency: "",
      access_right: {}
    };
  },

  mixins: [accessible],

  methods: {
    inProgress() {
      alert("in progress");
    },
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.itemPagination.itemsPerPage;
      this.getList(1);
    },
    retry() {
      this.getList(1);
    },
    onStoreChange(){
      this.$api
        .getAPI({
          _action: `/category/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}&items=0`,
          _body: {
            store_id : this.filterObj.store_id
          }
        })
        .then(res => {
          this.categories = res.list;
          this.getList(1);
        });
    },
    getList(page, sortBy, orderBy) {
      this.checkedItems = [];

      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      this.$api
        .getAPI({
          _action: "/item/list/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.itemPagination.setTotalCount(res.count);
            } else {
              this.$refs.itemPagination.setTotalCount(0);
            }
          }
          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_items_found
            );
          } else {
            if (this.$refs.errorComonent.isShowMessage()) {
              this.$refs.errorComonent.setTitle();
            } else {
              this.checkUncheckItems();
            }
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    showDeleteItemsAlert() {
      this.$refs.deleteMultipleItemLink.click();
      this.$refs.deleteMultipleItemAlert.message = this.$lang.messages.delete_multiple_items_message;
    },
    deleteSelectedItem() {
      for (var i = 0; i < this.checkedItems.length; i++) {
        this.$api
          .deleteAPI({
            _action: "/item/delete/" + this.checkedItems[i]
          })
          .then(res => {
            if (i == this.checkedItems.length) {
              this.getList(1);
              this.checkedItems = [];
              this.$refs.spr_1.checked = false;
              this.$refs.deleteMultipleItemAlert.close();
              this.$notify({
                group: "foo",
                text: this.$lang.messages.deleted_successfully,
                type: "success"
              });
            }
          })
          .catch(e => {
            this.getList();
          });
      }
    },
    setObj(id) {
      this.item_obj.id = id;
      this.$refs.deleteItemAlert.message = this.$lang.messages.are_you_sure_you_want_to_delete_the_item;
    },
    deleteItem(e) {
      if (this.item_obj.id) {
        this.$api
          .deleteAPI({
            _action: "/item/delete/" + this.item_obj.id
          })
          .then(res => {
            this.$refs.deleteItemAlert.close();
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            this.item_obj.id = "";
            this.getList(1);
          })
          .catch(e => {
            this.$refs.deleteItemAlert.close();
          });
      }
    },

    gotoItemEdit(id) {
      router.push("/edit-item/" + id);
    },
    checkAllcheckedItems(event) {
      this.checkedItems = [];
      if (event.target.checked) {
        for (var i = 0; i < this.list.length; i++) {
          this.checkedItems.push(this.list[i].id);
        }
      }
    },
    checkUncheckItems() {
      if (this.$refs.spr_1.checked) {
        if (
          this.checkedItems.length > 0 &&
          this.checkedItems.length == this.list.length
        ) {
          this.$refs.spr_1.checked = true;
        } else {
          this.$refs.spr_1.checked = false;
        }
      }
    },
    getAllStoreList() {
      this.$api
        .getAPI({
          _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.stores = res.list;
        });
    },
    getAllCategoryList() {
      this.$api
        .getAPI({
          _action: `/category/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}&items=0`,
        })
        .then(res => {
          this.categories = res.list;
        });
    },
    getExport() {
      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/item/export_item/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'items.csv'})
    },
  },

  mounted() {
    $(".search-box a, .search-box .app-search .srh-btn").on(
      "click",
      function() {
        $(".app-search").toggle(200);
        $(".app-search input").focus();
      }
    );

    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;

    EventBus.$on("GET_ME_SUCCESS", payload => {
      this.access_right = payload.access_right;
      this.currentUser = payload
      this.getAllStoreList();
      this.getAllCategoryList();
      this.getList(1);
    });
  }
};
</script>

<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="text-md-right">
            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-lg-3 mr-md-1 mb-3 w-xs-100"
              style="width: 160px;">
              <select v-model="filterObj.category_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.category}}</option>
                <option
                  v-for="category in categories"
                  :key="category.id"
                  :value="category.id"
                >{{category.name}}</option>
              </select>
            </div>

            <div
              class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
              style="width: 160px;">
              <select v-model="filterObj.stock" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.stock_alert}}</option>
                <option value="low_stock">{{$lang.messages.low_stock}}</option>
                <option value="out_stock">{{$lang.messages.out_stock}}</option>
              </select>
            </div>

            <div
              class="text-right custom-select-dd d-inline-block mr-lg-3 mr-md-1 mb-lg-0 mb-3 w-xs-100"
              style="width: 160px;">
              <select v-model="filterObj.store_id" @change="onStoreChange()" class="form-control">
                <option value>{{$lang.messages.stores}}</option>
                <option v-for="store in stores" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>

            <button
              type="button"
              v-if="checkedItems && checkedItems.length > 0"
              @click="showDeleteItemsAlert()"
              class="btn btn-light font-18 mb-3 mb-lg-0"
              style="float: left">
              <i class="far fa-trash-alt font-16 text-seconadry"></i>
            </button>
            <button
              type="button"
              class="btn bg-white search-box border-secondary rounded-5 mr-3 mr-lg-3 mr-md-0 mb-lg-0 mb-3"
              style="height: 42px">
              <a class="text-secondary waves-effect waves-dark p-0" href="javascript:void(0)">
                <i class="fas fa-search font-16"></i>
              </a>
              <form class="app-search position-absolute" v-on:submit.prevent>
                <input
                  type="text"
                  class="form-control"
                  v-model="filterObj.search"
                  :placeholder="$lang.messages.search_enter"
                  v-on:keyup.enter="getList(1)"/>
                <a class="srh-btn">
                  <i class="ti-close"></i>
                </a>
              </form>
            </button>
            <button v-if="!!access_right.create_items"
              @click="checkPendingAccountStatus($event, 'add-item')"
              class="btn btn-primary px-4 mb-3 mb-lg-0">+ {{$lang.messages.add_item}}</button>
          </div>

          <div class="card rounded-5">
            <div class="bg-white mt-3">
              <div class="pink-tape py-1">
                <div class="row">
                  <div class="col-lg-9 col-md-6 col-5 align-self-center">
                    <a
                      href="javascript:void(0)"
                      class="font-20 mb-0 text-regular text-hover-primary text-nowrap mr-2"
                      @click="getExport()"
                    >
                      {{$lang.messages.export}}
                      <i class="mdi mdi-download align-text-top"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body table-responsive">
              <table class="table table-striped table-style-1">
                <thead>
                  <tr>
                    <th width="45">Sr.no</th>
                    <th width="45"></th>
                    <th scope="col" width="64">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          id="spr_1"
                          ref="spr_1"
                          @change="checkAllcheckedItems($event)"
                        />
                        <label class="custom-control-label text-dark ml-2" for="spr_1"></label>
                      </div>
                    </th>
                    <th
                      width="345"
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'name')"
                    >{{$lang.messages.item_name}}</th>
                    <th
                      width="145"
                      scope="col"
                      class="sorting"
                      @click="sorting($event, 'category_name')"
                    >{{$lang.messages.category}}</th>
                    <th
                      width="85"
                      scope="col"
                      class="sorting text-center"
                      @click="sorting($event, 'price')"
                    >{{$lang.messages.price}}</th>
                    <th
                      width="82"
                      scope="col"
                      @click="sorting($event, 'cost')"
                      class="sorting text-center"
                    >{{$lang.messages.cost}}</th>
                    <th scope="col" class="text-center" width="104">{{$lang.messages.margin}}</th>
                    <th scope="col" class="text-center" width="115">{{$lang.messages.in_stock}}</th>
                    <th scope="col" width="104"></th>
                    <th scope="col" width="104"></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, index) in list">
                    <tr :key="'item_'  +index">
                      <td>{{(currentPage -1) * itemsPerPage + index +1}}</td>
                      <td v-if="item.is_variant">
                        <a
                          class="text-primary font-18 toggle-this collapsed"
                          data-toggle="collapse"
                          :href="'#collapse_row_'+index"
                          aria-expanded="false"
                          :aria-controls="'#collapse_row_'+index"
                        >
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </a>
                      </td>
                      <td v-else></td>
                      <td>
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :value="item.id"
                            :id="'type_'  +item.id"
                            v-model="checkedItems"
                            @change="checkUncheckItems($event)"
                          />
                          <label
                            class="custom-control-label text-dark ml-2"
                            :for="'type_' +item.id"
                          ></label>
                        </div>
                      </td>
                      <td>{{item.name}}</td>
                      <td>{{item.category_name ? item.category_name : $lang.messages.no_category}}</td>
                      <td class="text-center" v-if="!item.is_variant">
                        <vue-numeric
                          v-if="item.price"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.price"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>{{$lang.messages.variable}}</template>
                      </td>
                      <td v-else></td>
                      <td class="text-center" v-if="!item.is_variant">
                        <vue-numeric
                          v-if="item.cost"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.cost"
                          :read-only="true"
                        ></vue-numeric>
                      </td>
                      <td v-else></td>
                      <td class="text-center">{{item.margin != null ? item.margin + '%' : '-' }}</td>
                      <td class="text-center">{{item.in_stock ? item.in_stock : '-' }}</td>
                      <td class="text-center" v-if="item.out_count && item.low_count">
                        <span class="text-danger">
                          <b>{{$lang.messages.out_stock}} ({{item.out_count}})</b>
                          <br />
                          <b>{{$lang.messages.low_stock}} ({{item.low_count}})</b>
                        </span>
                      </td>
                      <td class="text-center" v-else-if="item.out_count">
                        <span class="text-danger">
                          <b>{{$lang.messages.out_stock}} ({{item.out_count}})</b>
                        </span>
                      </td>
                      <td class="text-center" v-else-if="item.low_count">
                        <span class="text-danger">
                          <b>{{$lang.messages.low_stock}} ({{item.low_count}})</b>
                        </span>
                      </td>
                      <td class="text-center" v-else></td>
                      <td class="text-right text-nowrap">
                        <a v-if="!!access_right.menu_items"
                          href="javascript:void(0)"
                          @click="gotoItemEdit(item.id)"
                          class="text-primary mr-2 font-18"
                        >
                          <i class="mdi mdi-pencil"></i>
                        </a>
                        <a v-if="!!access_right.menu_items"
                          href="javascript:void(0)"
                          data-toggle="modal"
                          data-target="#delete-item-modal"
                          @click="setObj(item.id)"
                        >
                          <i class="far fa-trash-alt font-20 text-danger"></i>
                        </a>
                      </td>
                    </tr>
                    <tr class="collapse multi-collapse" :id="'collapse_row_'+index"  :key="index">
                      <td colspan="10" class="border-0 p-0">
                        <table class="w-100">
                          <tr
                            class="border-0"
                            v-for="(item_variant , i) in item.item_variant_combination"
                            :key="'var_'  +index+'_'+i"
                          >
                            <td class="border-0" width="45"></td>
                            <td class="border-0" width="64"></td>
                            <td class="border-0" width="354">{{item_variant.value}}</td>
                            <td class="border-0" width="154">{{item_variant.category_name}}</td>
                            <td class="border-0 text-center" width="85" v-if="item_variant.price">
                              <vue-numeric
                                v-if="item_variant.price"
                                v-bind:precision="precision"
                                :separator="decimal_separator"
                                :currency="currency"
                                :value="item_variant.price"
                                :read-only="true"
                              ></vue-numeric>
                            </td>
                            <td
                              class="border-0 text-center"
                              width="85"
                              v-else
                            >{{$lang.messages.variable}}</td>
                            <td class="border-0 text-center" width="82">
                              <vue-numeric
                                v-if="item_variant.cost"
                                v-bind:precision="precision"
                                :separator="decimal_separator"
                                :currency="currency"
                                :value="item_variant.cost"
                                :read-only="true"
                              ></vue-numeric>
                            </td>
                            <td
                              class="border-0 text-center"
                              width="104"
                            >{{item_variant.margin != null ? item_variant.margin + '%' : '-' }}</td>
                            <td
                              class="border-0 text-center"
                              width="115"
                            >{{item_variant.in_stock ? item_variant.in_stock : '-' }}</td>
                            <td
                              class="border-0 text-right"
                              width="104"
                              v-if="item_variant.out_count && item_variant.low_count"
                            >
                              <span class="text-danger">
                                <b>{{$lang.messages.out_stock}} ({{item_variant.out_count}})</b>
                                <br />
                                <b>{{$lang.messages.low_stock}} ({{item_variant.low_count}})</b>
                              </span>
                            </td>
                            <td
                              class="border-0 text-right"
                              width="104"
                              v-else-if="item_variant.out_count"
                            >
                              <span class="text-danger">
                                <b>{{$lang.messages.out_stock}} ({{item_variant.out_count}})</b>
                              </span>
                            </td>
                            <td
                              class="border-0 text-right"
                              width="104"
                              v-else-if="item_variant.low_count"
                            >
                              <span class="text-danger">
                                <b>{{$lang.messages.low_stock}} ({{item_variant.low_count}})</b>
                              </span>
                            </td>
                            <td class="border-0 text-right" width="104" v-else></td>
                            <td class="border-0 text-right" width="104"></td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <ErrorComponent @retry="retry()" ref="errorComonent" />
            </div>
          </div>

          <div class="page-bottom-pagination text-right">
            <Pagination
              @page-change="pageChange"
              @items-per-page-change="itemsPerPageChange"
              ref="itemPagination"
            />
          </div>
        </div>
      </div>
    </div>

    <Alert
      @rightButtonEvent="deleteSelectedItem($event)"
      v-bind:title="$lang.messages.delete_item"
      ref="deleteMultipleItemAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-multiple-item-modal"
    />

    <a
      data-toggle="modal"
      data-target="#delete-multiple-item-modal"
      ref="deleteMultipleItemLink"
      style="display: none"
    />

    <Alert
      @rightButtonEvent="deleteItem($event)"
      v-bind:title="$lang.messages.delete_item"
      ref="deleteItemAlert"
      tabindex="-1"
      aria-hidden="true"
      role="dialog"
      class="modal fade show"
      id="delete-item-modal"
    />
  </div>
</template>
